import { Lot } from '../../model/dto/lot';
import { CalibrationErrorResponse } from '../../model/dto/calibration-error-response';
import { HormoneModelFitParameters } from '../../model/dto/hormone-model-fit-parameters';

export type CalibrationCartridgeType = 'lr_e3g' | 'lh' | 'pg' | 'testosterone';

export type CalibrationResult =
  | { status: 'calibrated'; lotFields: Partial<Lot> }
  | { status: 'failed'; errorMessage: string }
  | { status: 'ignored' };

const MODEL_FIT_PARAMETER_FIELDS: Partial<
  Record<CalibrationCartridgeType, keyof Lot>
> = {
  lh: 'lh_model_fit_parameters',
  pg: 'pg_model_fit_parameters',
  lr_e3g: 'lr_e3g_model_fit_parameters',
};

export function getCalibrationResult(
  cartridgeType: CalibrationCartridgeType,
  response: HormoneModelFitParameters & CalibrationErrorResponse
): CalibrationResult {
  if (!response.success) {
    return { status: 'failed', errorMessage: response.error_message };
  }

  const field = MODEL_FIT_PARAMETER_FIELDS[cartridgeType];

  if (!field) {
    return { status: 'ignored' };
  }

  return { status: 'calibrated', lotFields: { [field]: response } };
}
